<template>
    <div>
        <DCard
            padding
        >
            <ResellerContractsTable
                :customer="customer"
                :reseller-contracts="resellerContracts"
                :filters="filters"
                @changePage="changePage"
            />
            <DFabs>
                <s-s-o-fab
                    :customer="customer"
                    @open-modal="showCreateCloudpitCustomerModal = true"
                    @close-modal="showCreateCloudpitCustomerModal = false"
                />
                <DFab
                    v-if="userPermissions.includes('contract.edit') && contract.status !== 'terminated' && contract.status !== 'cancelled'"
                    icon="pencil"
                    :label="__('messages.actions.edit')"
                    @click="editContract"
                />
            </DFabs>
            <CreateCloudPitCustomerModal
                :customer="customer"
                :show-modal="showCreateCloudpitCustomerModal"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'
import ResellerContractsTable from '~@/Components/Customers/Contracts/ResellerContractsTable'

export default {
    name: 'CustomerResellerContractShow',
    components: {
        ResellerContractsTable,
        SSOFab,
        CreateCloudPitCustomerModal
    },
    layout: [App, CustomerBase],
    props: {
        customer: {
            type: Object,
            default: () => { return {} }
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        resellerContracts: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            showCreateCloudpitCustomerModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        changePage (page, queryParameters) {
            if (page === 1) {
                delete queryParameters.page
            }

            this.$inertia.get(this.$route('customers.customers.contracts.reseller_contracts', {
                customer: this.customer.id,
                contract: this.contract.id,
                ...queryParameters
            }))
        },
        editContract () {
            this.$inertia.get(this.$route('customers.customers.contracts.edit', {
                customer: this.customer.id,
                contract: this.contract.id
            }))
        }
    }
}
</script>
